/**
 * @copyright WaterStreet. All rights reserved.
*/

/* eslint-disable max-len */

import {
	CommonModule
} from '@angular/common';
import {
	NgModule
} from '@angular/core';
import {
	RouterModule
} from '@angular/router';
import {
	GenericBasePageComponent
} from '@appComponents/generic-base-page/generic-base-page.component';
import {
	EntityFormComponent
} from '@entity/components/entity-form/entity-form.component';
import {
	EntityInstanceComponent
} from '@entity/components/entity-instance/entity-instance.component';
import {
	EntitySearchComponent
} from '@entity/components/entity-search/entity-search.component';
import {
	ParentSelectionComponent
} from '@entity/components/wizard-steps/parent-selection/parent-selection.component';
import {
	EntityComponent
} from '@entity/entity.component';
import {
	EntityService
} from '@entity/services/entity.service';
import {
	AppAuthGuard
} from '@shared/guards/app-auth.guard';
import {
	AppCanDeactivateGuard
} from '@shared/guards/app-can-deactivate.guard';
import {
	EntityDeepLinkTranslatorGuard
} from '@shared/guards/entity-deep-link-translator.guard';
import {
	ModuleGuard
} from '@shared/guards/module.guard';
import {
	SharedModule
} from '@shared/shared.module';
import {
	MarkdownModule
} from 'ngx-markdown';

/* eslint-enable max-len */

@NgModule({
	declarations: [
		EntityComponent,
		EntityFormComponent,
		EntityInstanceComponent,
		EntitySearchComponent,
		EntityComponent,
		EntityFormComponent,
		EntityInstanceComponent,
		EntitySearchComponent,
		ParentSelectionComponent
	],
	imports: [
		CommonModule,
		MarkdownModule.forChild(),
		SharedModule,
		RouterModule.forChild([
			{
				path: ':moduleName/entities',
				component: EntityComponent,
				canActivate: [
					AppAuthGuard,
					ModuleGuard
				],
				children: [
					{
						path: ':entityType/view/:id',
						component: EntityInstanceComponent,
						data: {
							refreshComponent: true
						}
					},
					{
						path: ':entityType/edit/:id',
						component: EntityInstanceComponent,
						data: {
							refreshComponent: true
						}
					},
					{
						path: ':entityType/:id',
						component: EntitySearchComponent,
						canActivate: [
							EntityDeepLinkTranslatorGuard
						]
					},
					{
						path: 'display',
						children: [
							{
								path: ':displayComponent/create',
								component: GenericBasePageComponent,
								data: {
									refreshComponent: true
								}
							}
						]
					},
					{
						path: '',
						component: EntitySearchComponent,
						data: {
							refreshComponent: true
						}
					}
				]
			}])
	],
	exports: [
		ParentSelectionComponent
	],
	providers: [
		AppCanDeactivateGuard,
		EntityService,
		ParentSelectionComponent
	]
})

/**
 * A module used to hold entity route specific
 * logic and display resources.
 *
 * @export
 * @class EntityModule
 */
export class EntityModule
{
}